export const UpdateEditRestriction = (isAllowed) => {
  return {
    type: 'EDIT_RESTRICTION',
    payload: {isAllowed}
  };
};
